// Charge la base commune
import './common.js'

// Financing Form
async function getFForm ($f) {
  import(/* webpackChunkName: "financingForm" */ './js/components/financingForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire de simulation de financement
  const $f = $('form[name="fForm"]')
  $f.waypoint(function () {
    $f.load()
    getFForm($f)
    this.destroy()
  }, {
    offset: '100%'
  })
})
